module.exports = __webpack_public_path__ + "static/media/event-services-img5.222027c4.jpg";